<template>
  <div class="flexSB w-full flex-shrink-0">
    <div class="leftDiv">
      <div
        class="one"
        v-for="(item, index) in menuLeft"
        :class="[menuLeftIndex == index + 1 ? 'active' : '']"
        :key="'menuLeft' + index"
        @click="clickMenuLeft(index + 1)"
      >
        <div class="flexCB tran" :class="menuLeftIndex != index + 1 && 'cur'">
          <span class="flexCS font18">
            <i class="iconfont" :class="item.icon"></i>
            {{ item.name }}
          </span>
          <i class="el-icon-arrow-down flexCC tran"></i>
        </div>
        <ul class="tran" v-if="(item.arr || []).length > 0">
          <li
            class="font18 cur tran active flex items-center"
            v-for="(item2, index2) in item.arr"
            :key="'item.arr' + index2"
            @click="clickMenuLeftLi(item2, index + 1 + '-' + index2 + 1)"
          >
            <img class="tran" src="@/assets/img/mainIconRight.png" alt="" />
            <p :class="{ 'text-cyan-400': isActive(item2) }">
              {{ item2.name }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      // 左侧菜单
      menuLeft: [
        {
          name: "AI",
          icon: "icon-sousuo",
          arr: [
            {
              name: "AI 诊股",
              location: {
                path: "/aiChat",
              },
            },
            {
              name: "名人诊股",
              location: {
                path: "/famousChat",
              },
            },
            {
              name: "机构诊股",
              location: {
                path: "/institutionChat",
              },
            },
            {
              name: "仓位建议",
              location: {
                path: "/positionSuggest",
              },
            },
          ],
        },
        {
          name: "股票",
          icon: "icon-neidigupiao",
          location: {
            path: "/aiMain",
          },
        },

        {
          name: "期货",
          icon: "icon-qihuo",
          location: {
            path: "/aiMain",
            query: {
              type: "futures",
            },
          },
        },
        {
          name: "数字货币",
          icon: "icon-qihuo",
          location: {
            path: "/aiMain",
            query: {
              type: "crypto",
            },
          },
        },
        {
          name: "自选",
          icon: "icon-qiquan",
          location: {
            path: "/selfStock",
            query: {
              isSelf: 1,
            },
          },
        },
        {
          name: "机会",
          icon: "icon-nengli",
          arr: [
            {
              name: "涨停盘推荐",
              location: {
                path: "/recommend",
              },
            },
            {
              name: "板块推荐",
              location: {
                path: "/boardRecommend",
              },
            },
            {
              name: "买卖点盯盘",
              location: {
                path: "/watchStrategy",
                query: {
                  type: "stock",
                  stockType: "point",
                },
              },
            },
            /* {
              name: "期货拐点",
              location: {
                path: "/watchStrategy",
                query: {
                  type: "futures",
                  futuresType: "point",
                },
              },
            },
            {
              name: "期货趋势",
              location: {
                path: "/watchStrategy",
                query: {
                  type: "futures",
                  futuresType: "trend",
                },
              },
            },
            {
              name: "图形相似搜索",
              location: {
                path: "/aiSearchInfo",
              },
            }, */
            {
              name: "智能投顾",
              location: {
                path: "/aiInvestment/trade",
              },
            },
            {
              name: "K线智能选股",
              location: {
                path: "/aiKlineStock",
              },
            },
          ],
        },
        {
          name: "电报",
          icon: "icon-baobiaoguanli",
          location: {
            path: "/telegram",
          },
        },
      ],
      // 菜单分类选中
      menuLeftIndex: 0,
      // 菜单子类选中
      menuLeftLiIndex: "",
    };
  },
  methods: {
    // 点击菜单分类
    clickMenuLeft(num) {
      if (!num) return;

      // 如果点击的是当前展开的菜单，则收起
      if (this.menuLeftIndex === num) {
        this.menuLeftIndex = 0;
        sessionStorage.removeItem("menuLeftIndex");
        return;
      }

      this.menuLeftIndex = JSON.parse(JSON.stringify(num));
      sessionStorage.setItem("menuLeftIndex", JSON.stringify(num));

      // 只有当菜单项没有子菜单时才进行路由跳转
      if (
        !this.menuLeft[num - 1].arr ||
        this.menuLeft[num - 1].arr.length === 0
      ) {
        this.$router.push(this.menuLeft[num - 1].location);
      }
    },
    // 点击菜单子类
    clickMenuLeftLi(obj, str) {
      console.log("clickMenuLeftLi", "obj", obj, "str", str);
      if (!obj || !str) return;

      this.menuLeftLiIndex = JSON.parse(JSON.stringify(str));
      sessionStorage.setItem("menuLeftLiIndex", JSON.stringify(str));
      this.menuLeftIndex = JSON.parse(JSON.stringify(str.split("-")[0]));
      sessionStorage.setItem(
        "menuLeftIndex",
        JSON.stringify(str.split("-")[0])
      );
      this.$router.push(obj.location);
    },
    // 二级菜单高亮逻辑
    isActive(menuItem) {
      // 比较路径
      if (menuItem.location.path !== this.$route.path) {
        return false;
      }

      // 比较查询参数
      const menuQuery = menuItem.location.query || {};
      const currentQuery = this.$route.query || {};
      for (const key in menuQuery) {
        if (menuQuery[key] !== currentQuery[key]) {
          return false;
        }
      }
      return true;
    },
  },
  created: function () {
    const menuLeftIndexJSON = sessionStorage.getItem("menuLeftIndex");
    if (menuLeftIndexJSON) {
      this.menuLeftIndex = JSON.parse(menuLeftIndexJSON);
      sessionStorage.removeItem("menuLeftIndex");
    }

    const menuLeftLiIndexJSON = sessionStorage.getItem("menuLeftLiIndex");
    if (menuLeftIndexJSON) {
      this.menuLeftLiIndex = JSON.parse(menuLeftLiIndexJSON);
      sessionStorage.removeItem("menuLeftLiIndex");
    }
  },
};
</script>
<style lang="scss" scoped>
.leftDiv {
  width: 100%;
  height: calc(100vh - 10rem);
  overflow: hidden;
  overflow-y: auto;
  color: #fff;

  .one {
    width: 100%;
    height: 6rem;
    overflow: hidden;
    margin: 0 0 1rem 0;

    &:hover > div {
      background: url("@/assets/img/mainBtnA.png") no-repeat;
      background-size: 100% 100%;
    }

    &.active {
      height: auto;

      > div {
        background: url("@/assets/img/mainBtnA.png") no-repeat;
        background-size: 100% 100%;

        > span {
          color: #fff;

          > i {
            color: #fff;
          }
        }

        > i {
          color: #fff;
          transform: rotate(-180deg);
        }
      }

      > ul {
        transform: scaleY(1);
        opacity: 1;
      }
    }

    &.active2 {
      //

      > div {
        background: url("@/assets/img/mainBtnA.png") no-repeat;
        background-size: 100% 100%;

        > span {
          color: #fff;

          > i {
            color: #fff;
          }
        }

        > i {
          color: #fff;
        }
      }
    }

    > div {
      height: 6rem;
      overflow: hidden;
      padding: 0 2.5rem 0 3rem;
      background: url("@/assets/img/mainBtn.png") no-repeat;
      background-size: 100% 100%;
      transition: all 0.3s ease;

      > span {
        width: calc(100% - 2.1rem);
        overflow: hidden;

        > i {
          overflow: hidden;
          margin: 0 1.5rem 0 0;
          font-size: 2rem;
        }
      }

      > i {
        width: 2rem;
        overflow: hidden;
        transition: all 0.3s ease;
      }
    }

    > ul {
      width: 100%;
      overflow: hidden;
      padding: 1rem 0;
      transform: scaleY(0);
      transform-origin: top;
      transition: all 0.3s ease;
      height: auto;
      opacity: 0;
      background: linear-gradient(
        to top,
        rgba(46, 53, 65, 0.6) 0%,
        rgba(20, 24, 35, 0.2) 100%
      );

      > li {
        height: 6rem;
        overflow: hidden;
        padding: 0 2.5rem;
        background: url("@/assets/img/mainBtn.png") no-repeat;
        background-size: 100% 100%;

        &:hover,
        &.active {
          color: #fff;

          > img {
            opacity: 1;
          }
        }

        > img {
          width: 2.5rem;
          height: auto;
          overflow: hidden;
          margin: 0 0.5rem 0 0;
          opacity: 0;
        }
      }
    }
  }
}
</style>